import { Injectable } from '@angular/core';

@Injectable()
export class DBkeys {



    public static readonly LANGUAGE = 'language';
}